var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advantages__wrapper"},[_c('div',{staticClass:"advantages__bg",style:({
      background:
        'url(' +
        require(("../../assets/img/icons/" + _vm.source)) +
        ') center center/cover no-repeat',
    })}),_c('div',{staticClass:"advantages__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"advantages__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }